import { render, staticRenderFns } from "./SetupStep6.vue?vue&type=template&id=5b560ce7&"
import script from "./SetupStep6.vue?vue&type=script&lang=ts&"
export * from "./SetupStep6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports